import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Dashboard.css";

function DashboardPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Dashboard Page</h1>
                <p className="main-description">Welcome to the dashboard page!</p>
            </main>
        </div>
    );
}

export default DashboardPage;